import {
  ON_GET_BUSINESS_USER,
  ADD_BUSINESS_USER,
  BUSINESS_USER_ERROR,
  GET_BUSINESS_USERS,
  GET_BUSINESS_USER,
} from "../../actions/types";

const initialState = {
  businessUsers: [],
  businessUser: null,
  loading: true,
  error: {},
};

export default function foo(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case ON_GET_BUSINESS_USER:
      return {
        ...state,
        loading: true,
      };
    case ADD_BUSINESS_USER:
      return {
        ...state,
        businessUser: payload,
        loading: false,
      };
    case GET_BUSINESS_USER:
      return {
        ...state,
        businessUser: payload,
        loading: false,
      };
    case GET_BUSINESS_USERS:
      return {
        ...state,
        businessUsers: payload,
        loading: false,
      };
    case BUSINESS_USER_ERROR:
      return {
        ...state,
        error: payload,
        loading: false,
      };
    default:
      return state;
  }
}
